<div *ngIf="fields && fields.length > 0"
     class="filters-container">
  <!-- affichage des champs / valeurs filtrés -->
  <ng-container *ngFor="let filter of fields; let idx = index">
    <button
      (click)="reinitFilter(filter)"
      class="filters-buttons"
      mat-stroked-button
      color="accent"
      [matTooltip]="getToolTipButtonFilter(filter)"
      style="margin-left: 2px; margin-right: 2px;">
      <mat-icon data-cy="icon-filter-enable-cancel">cancel</mat-icon> {{filter.label}} : {{getValue(filter)}}
    </button>
    <span *ngIf="fields.length > 1 && idx < fields.length - 1"
          class="button-and">ET</span>
  </ng-container>
  <!-- enlever tous les filtres -->
  <ng-container *ngIf="fields.length > 1">
    <mat-divider [vertical]="true" ></mat-divider>
    <button mat-stroked-button
            style="margin-left: 5px;"
            matTooltip="enlever tous les filtres"
            class="filters-buttons"
            (click)="reinitFilters()"
            color="accent">
      <mat-icon>cancel</mat-icon> annuler tous les filtres
    </button>
  </ng-container>
</div>
